export default "__VITE_ASSET__7eE9vLAA__"